
interface IProps {
  onclkbtn: () => void;
}

export function FontScreen(props: IProps) {
  return (
    <>
      <div className="RegistrationConteinerText">
        <div className="textConteiner">
          <h2>
            Мы отправляемся в увлекательное путешествие по закоулкам женской
            души!
          </h2>

          <p>
            Давайте начнем с регистрации, чтобы сделать ваше взаимодействие с
            приложением комфортным и приятным.
          </p>
        </div>
      </div>
      <div className="registration-button" onClick={props.onclkbtn}>
        Далее
      </div>
    </>
  );
}
